import { apiCall } from '.';

export const countriesApi = () => {
  return apiCall(false).get('/countries');
};

export const statesApi = (countryId: string) => {
  return apiCall(false).get(`/states/${countryId}`);
};
